import React from 'react'
import { Link } from "react-router";
import {toPersianDigit} from '../../helpers/nums'
import { Badge } from "@sketchpixy/rubix";
import moment from "moment-jalaali";
// massage rows in main section
const InboxItem = ({ massageId, label, description, date, type }) => {
  const jalaliDate = toPersianDigit(moment(new Date(date)).format("jYYYY.jM.jD"));
  const wordCount = description.split(" ").length;
  const shortDesc =
    description.replace(/^(.{6}[^\s]*).*/, "$1") + (wordCount > 5 ? "..." : "");
  return (
    <div>
      <Link to={`/dashboard/messages/${type}/read/${massageId}`}>
        {/*
          sender name is not avaiable form api right now
          <div className="fg-darkgrayishblue75">
          <small>فرستنده: </small>{senderName}
        </div>
      */}
        <div>
          <small>
            <Badge
              className="bg-green fg-white"
              style={{
                marginLeft: 10,
                display: label ? "inline" : "none"
              }}
            >
              {label}
            </Badge>
            <span>{shortDesc}</span>
          </small>
        </div>
        <div className="inbox-date hidden-sm hidden-xs fg-darkgray40 text-right">
          <small>{jalaliDate}</small>
        </div>
      </Link>
      <hr />
    </div>
  );
};

export default InboxItem;



// WEBPACK FOOTER //
// ./src/components/common/InboxItem.js